import {createSlice} from '@reduxjs/toolkit'

export enum PageTypeEnum {
  市集寻宝 = 1,
  牧场大亨,
  狂欢奖池,
}

const initialState = {}
export const KillAnimalSlice = createSlice({
  name: 'KillAnimal',
  initialState,
  reducers: {},
  extraReducers: (builder) => {},
})
export default KillAnimalSlice.reducer
export const KillAnimalActions = KillAnimalSlice.actions
